import Vue from 'vue';

const success = (resolve) => {
  resolve();
};

const failed = (error, reject) => {
  const data = error.response && error.response.data;
  reject(data || error);
};

export default (id, product) => {
  const data = new FormData();
  Object.keys(product).map((k) => {
    data.append(k, product[k]);
    return null;
  });
  return new Promise((resolve, reject) => {
    Vue.$http
      .request({
        url: `/products/${id}/quick-update`,
        data,
        method: 'post',
      })
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  });
};



// WEBPACK FOOTER //
// ./src/app/services/product/quickUpdate.js